export default __webpack_public_path__ + "static/media/Project-3.84eb34b7.jpg";